import { Outlet } from 'react-router-dom';
import ProtectedRoutes from '../components/protectedRoutes/ProtectedRoutes';
import Sidebar from '../components/sidebar/Sidebar';
import BrandNavbar from '../components/navbar/BrandNavbar';

const BrandLayout = () => {
    return (
        <div>
            <ProtectedRoutes>
                <div className="d-flex">
                    <div style={{ width: "20%", position: "fixed" }}>
                        <Sidebar />
                    </div>
                    <div style={{ width: "80%", marginLeft: "20%" }}>
                        <BrandNavbar />
                        <div>
                            <Outlet />
                        </div>
                    </div>
                </div>
            </ProtectedRoutes>
        </div>
    );
};

export default BrandLayout;